  <template>
  <div class="ship-note-main">
    <ReportsHomeV2 :jsReport="false" title="Shipping Note" placeholder="Job No" @generateReport="generate" ref="report" :sections="sections" :inputValue.sync="jobNo">
      <div slot="Details_Report Type">
        <Dropdown placeholder="Shipping Note format" :items="formatList" itemKey="Format No" :selectedObject.sync="selectedFormat"
          :errorMessage.sync="formatError" :isRequired="true" />
      </div>
    </ReportsHomeV2>

    <Loader :isVisible.sync="loading" :loadingText="loadingText" :isFullScreen="true" />
    <PopupV2 :show="popupShow" :type="popupType" :title="popupTitle" :content="popupContent" @buttonClicked="popupShow = false" />
  </div>
</template>

<script>
/* eslint-disable */
import ReportsHomeV2 from '@/pages/ReportsV2/ReportsHome';

export default {
  components: {
    ReportsHomeV2
  },
  data: function() {
    return {
      sections: [
        { name: 'Details', child: ['Report Type'], show: true }
      ],
      
      loading: false,
      loadingText: '',

      jobDetails: null,
      jobNo: '',

      popupShow: false,
      popupType: '',
      popupTitle: '',
      popupContent: '',

      formatList: [
        //{ format: 'North Port', formatKey: 'NP' },
        //{ format: 'West Port', formatKey: 'WP' }, 
      ],
      selectedFormat: null,
      formatError: '',
    }
  },
  props: {
  },
  methods: {
    generate: async function() {
      this.formatError = '';
      if (!this.selectedFormat) {
        this.formatError = 'Please choose your format';
        return;
      }

      this.loading = true;
      this.loadingText = 'Getting Details';
      let details = await this.$apiCallV2(`/FreightForwarding/JobDetails?jobno=${this.jobNo}&rpt=RPTSN`);
      this.loading = false;

      if (details) {
        this.jobDetails = details['JobDetails']['Job'];

        let company = details['JobDetails']['Job']['Company'];
        if (company) {
          if (typeof company == 'object' && !Array.isArray(company)) {
            Object.keys(company).forEach(k => this.jobDetails['company_${k}'] = company[k]);
          }
        }
        
        this.$refs['report'].generateReportDesigner(`${this.selectedFormat['File Name']}.json`, this.jobDetails);
      } else {
        this.popupShow = true;
        this.popupType = 'error';
        this.popupTitle = 'Invalid Job No';
        this.popupContent = `Invalid Job No ${this.jobNo}`;
      }
    }
  },
  async mounted() {
    let query = this.$route.query;
    this.formatList = await this.$apiCallV2('/FreightForwarding/GetReportType', { report:"SHIPPINGNOTE" });
    this.selectedFormat = this.formatList.find(item => item['Format No'] === 'NORTHPORT'); // NORTHPORT as default format
    if (query['jobno']) {
      this.jobNo = query['jobno'];
       await this.generate();
    }
  },
  watch: {
  }
}
</script>

<style lang="scss" scoped>
@import '@/css/all.scss';

.ship-note-main {
  width: 100%;
  height: 100%;
}
</style>


